import {
  ORDERS_CREATE,
  ORDERS_ACTIVE,
  ORDERS_CHANGE_QUANTITY,
} from "../../configs/api-config";
import { requestHelper } from "../../helpers/request-helper";
import axios from "axios";
import { formatAndRaiseError } from "../../helpers/general";

export {
  create_order_api,
  get_active_order_api,
  change_quantity_api,
  get_order_by_id_api,
};

function create_order_api(payload: any = { items: [] }) {
  return axios.post(ORDERS_CREATE, payload);
}

function get_active_order_api() {
  return axios.get(ORDERS_ACTIVE);
}

function get_order_by_id_api(id) {
  return requestHelper(
    `
    query singleOrder($id: String!) {
      retrieveOrder(id: $id) {
        id
        display_id
        services {
          id
          alias
          name
          display_name
          description
          unit
          pricing {
            id
            price
            variation {
              id
              alias
              name
              display_name
            }
          }
        }
        legacyLogistics {
          collection {
            id
            period {
              id
              date
              start
              end
            }
            status
            address_text
            address_latitude
            address_longitude
 
          }
          delivery {
            id
            period {
              id
              date
              start
              end
            }
            status
            address_text
            address_latitude
            address_longitude

          }
        }
        items {
          id
          service
          variation
          coefficient
          discount
          price
        }
        metadata {
          legacy_latest_status
          legacy_factor_link
          can_cancel
        }
        legacyPromotion {
          code
          description
        }
        legacyInvoice {
          logistic_price
          discount
          total_items_amount
          total_amount
          total_price
          vat
          tax
          toll
          cash_back
          total_extra_charge
        }
        legacyHistoryLogistics {
          id
          task_type
          status
          address_text
          address_latitude
          address_longitude
          address_id 
          in_person
          period {
          id
          date
          start
          end
          title
          }
          driver {
          first_name
          last_name
          cellphone
          }
        }
      }
    }
    `,
    {
      id: id,
    }
  )
    .then((data) => {
      return data.retrieveOrder;
    })
    .catch(formatAndRaiseError);
}

function change_quantity_api({ order_id, product_id, quantity }) {
  return axios.put(ORDERS_CHANGE_QUANTITY(order_id), {
    product_id,
    quantity,
  });
}
